import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const DevelopmentSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const developmentContent = content[language].development;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="development" 
      ref={sectionRef}
      className="section"
      style={{ background: '#ffffff' }}
    >
      <div className="container">
        {/* Header */}
        <div className={`text-center mb-64 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <div style={{ 
            fontSize: '0.875rem',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            color: 'var(--stone)',
            marginBottom: '16px'
          }}>
            {developmentContent.investment}
          </div>
          <h2 className="mb-32">{developmentContent.title}</h2>
          <p style={{ maxWidth: '800px', margin: '0 auto', fontSize: '1.0625rem' }}>
            {developmentContent.intro}
          </p>
        </div>

        {/* Scope Cards */}
        <div className="grid-3" style={{ marginBottom: '80px' }}>
          {developmentContent.scope.map((item, index) => (
            <div
              key={item.title}
              className={`fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{
                padding: '40px 32px',
                background: 'var(--ivory)',
                transitionDelay: `${0.2 + index * 0.15}s`
              }}
            >
              <h4 className="mb-24" style={{ fontSize: '1.25rem', color: 'var(--olive)' }}>
                {item.title}
              </h4>
              <p style={{ fontSize: '0.9375rem' }}>{item.description}</p>
            </div>
          ))}
        </div>

        {/* Timeline */}
        <div 
          className={`text-center fade-in-up ${isVisible ? 'visible' : ''}`}
          style={{ transitionDelay: '0.6s' }}
        >
          <div style={{
            display: 'inline-block',
            padding: '20px 40px',
            border: '1px solid var(--stone)',
            fontSize: '0.9375rem',
            color: 'var(--charcoal)',
            letterSpacing: '0.5px'
          }}>
            {developmentContent.timeline}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DevelopmentSection;
